export const FormikFieldError: React.FC<{ meta?: any; text?: string }> = ({ meta, text }) => {
	const showError = (meta && meta.error && meta.touched) || text;

	if (!showError) {
		return null;
	}

	return (
		<div className="text-red-600 text-sm mt-1">
			{text || meta.error}
		</div>
	);
};